import { externalShipmentAffProductsByOrderValidate } from '../../application/dtos/external_shipment_aff_products_by_order_validate';

export class ExternalShipmentAffProductsByOrderEntity {
    constructor({ products }){
        this.products = products;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return externalShipmentAffProductsByOrderValidate(this);
    }
}